import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error, info);
    if (this.props.onError) {
      try {
        this.props.onError(error, info);
      } catch (_) {
        // swallow
      }
    }
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div className="errorlist" role="alert">
          <p>Something went wrong rendering this section.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
